// Converte una data dal formato YYYY-MM-DD al formato DD/MM/YYYY
export function formattaData(dataISO) {
  if (!dataISO) return '';
  const [anno, mese, giorno] = dataISO.split('-');
  return `${giorno}/${mese}/${anno}`;
}
